import React from 'react';

function csrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.getAttribute('content') : '';
}

// Submits asset codes via POST so FindME stores filters in session (large lists use Rails cache, not the URL).
export default function FindMeFormButton({
  codes = [],
  className,
  style,
  disabled,
  children = 'Open in FindME'
}) {
  const list = Array.isArray(codes) ? codes.filter(Boolean) : [];
  const isDisabled = disabled || list.length === 0;

  if (isDisabled) {
    return (
      <button type="button" className={className} style={style} disabled>
        {children}
      </button>
    );
  }

  return (
    <form method="post" action="/items/search" style={{ display: 'inline' }}>
      <input type="hidden" name="authenticity_token" value={csrfToken()} />
      <input type="hidden" name="view_assets" value="on" />
      <input type="hidden" name="em_assets_codes" value={list.join(',')} />
      <button type="submit" className={className} style={style}>
        {children}
      </button>
    </form>
  );
}
